var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedExcl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 30,
    viewBox: "0 0 6 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_501_7722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.32199 21.0771L0.11539 3.14369C0.00626402 1.52037 1.23379 0.115873 2.85711 0.0067473C4.48042 -0.102379 5.88492 1.12515 5.99405 2.74846C6.00253 2.87625 6.0014 3.0193 5.99405 3.14426L4.78745 21.0771C4.57937 23.2268 1.52724 23.2217 1.32199 21.0771Z",
    fill: "#F01717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05419 29.9997C4.38197 29.9997 5.45835 28.9233 5.45835 27.5956C5.45835 26.2678 4.38197 25.1914 3.05419 25.1914C1.7264 25.1914 0.650024 26.2678 0.650024 27.5956C0.650024 28.9233 1.7264 29.9997 3.05419 29.9997Z",
    fill: "#F01717"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_501_7722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.89166,
    height: 30,
    fill: "white",
    transform: "translate(0.108337)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedExcl);
export default __webpack_public_path__ + "static/media/red-excl.9817330c6e0c5c67b724bf11a90f9049.svg";
export { ForwardRef as ReactComponent };